import {
  DialogContent as MuiDialogContent,
  DialogContentProps as MuiDialogContentProps,
} from '@mui/material';
import { DialogContentSx } from './DialogContentProps';

type Props = MuiDialogContentProps;

function DialogContent(props: Props) {
  return (
    <MuiDialogContent {...props} sx={{ ...DialogContentSx, ...props.sx }} />
  );
}

export default DialogContent;
